import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconClose = props => {
  if (props.id !== "_svgiconclose") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 26 26" {...props}><path d="M19.3 5.4L5.4 19.3c-.2.2-.6.3-.8.1-.2-.2-.2-.5.1-.8L18.6 4.7c.2-.2.6-.3.8-.1.2.2.1.6-.1.8" /><path d="M18.6 19.3L4.7 5.4c-.2-.2-.3-.6-.1-.8s.5-.2.8.1l13.9 13.9c.2.2.3.6.1.8-.2.2-.6.1-.8-.1" /></svg>;
};

SvgIconClose.displayName = "_svgiconclose";
SvgIconClose.propTypes = {
  id: PropTypes.string
};
SvgIconClose.defaultProps = {
  id: ''
};
export default SvgIconClose;